/**
 * Browser User Timing entries for Ask Tiger latency, so the client half of a slow turn can be
 * read off exactly instead of from a screen recording: devtools Performance panel ("Timings"
 * track), or `performance.getEntriesByType("measure").filter(m => m.name.startsWith("ask-tiger:"))`
 * in the console. Local only — nothing is sent anywhere. Never throws.
 *
 * - `ask-tiger:token` — credential fetch from the host before each agent request
 * - `ask-tiger:turn:response` — turn POST until response headers (includes the token fetch, the
 *   gateway, any AgentCore microVM boot, and any 409 retries)
 * - `ask-tiger:turn:first-event` — turn POST until the first stream event
 * - `ask-tiger:warmup` — panel-open warm-up round trip
 *
 * Compare `turn:response` with the server's `request_total`/`first_content` AgentStageTiming
 * lines: the gap is what happened before the agent process saw the request.
 */
export function measureSince(name: string, start: number): void {
  try {
    performance.measure(name, { start, end: performance.now() });
  } catch {
    // Unsupported User Timing L3 (old WebViews): skip the entry.
  }
}
